var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"br-pop-btn",style:({
    backgroundColor: _vm.button && _vm.button.background_color,
    color: _vm.button && _vm.button.text_color,
  }),on:{"click":function($event){$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('span',{staticClass:"iconfont icon-cm-xiajiantou-cu",class:{ active_icon: _vm.active }}),_vm._v(" "),_c('span',{staticClass:"br-btn-name"},[_vm._v(" "+_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }